import styled, { css } from 'styled-components';
import { Button } from '@/components/UI/Button/Button';
import { BtnPosition } from '@/components/AdImages/AdImages.types';

function getStylesForBtnPosition(position?: BtnPosition, isSmall?: boolean) {
  const side = isSmall ? '3px' : '5px';
  switch (position) {
    case 'tr': {
      return css`
        top: ${side};
        right: ${side};
      `;
    }
    case 'br': {
      return css`
        bottom: ${side};
        right: ${side};
      `;
    }
    case 'bl': {
      return css`
        bottom: ${side};
        left: ${side};
      `;
    }

    default: {
      return css``;
    }
  }
}

export const AdImagesItemBox = styled.div<{ $isSmall?: boolean }>`
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  position: relative;
  height: 105px;
  width: 105px;

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      height: 70px;
      width: 70px;
    `}
`;

export const AdImagesImage = styled.img<{ $rotateAngle: number }>`
  border-radius: 7px;
  object-fit: cover;
  transform: rotate(${({ $rotateAngle }) => $rotateAngle}deg);
  transition: transform 0.3s ease-in-out;
`;

export const AdImagesItemBtn = styled(Button)<{
  $position: BtnPosition;
  $isMirrored?: boolean;
  $isSmall?: boolean;
}>`
  position: absolute;

  ${({ $position, $isSmall }) => getStylesForBtnPosition($position, $isSmall)}

  ${({ $isMirrored }) =>
    !$isMirrored &&
    css`
      transform: rotateY(180deg);
    `}

  ${({ $isSmall }) =>
    $isSmall &&
    css`
      width: 20px;
    `}
`;
